const DownloadIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.2498 20.5001C18.664 20.4999 19 20.8356 19 21.2498C19 21.6641 18.6644 21.9999 18.2502 22.0001L5.25022 22.0038C4.836 22.0039 4.5 21.6683 4.5 21.254C4.5 20.8398 4.83557 20.5039 5.24978 20.5038L18.2498 20.5001ZM11.6482 2.01185L11.75 2.005C12.1297 2.005 12.4435 2.28716 12.4932 2.65323L12.5 2.755L12.499 16.44L16.2208 12.7197C16.4871 12.4534 16.9038 12.4293 17.1974 12.6472L17.2815 12.7198C17.5477 12.9861 17.5719 13.4027 17.354 13.6963L17.2814 13.7804L12.2837 18.7771C12.0176 19.0431 11.6012 19.0675 11.3076 18.8499L11.2235 18.7774L6.22003 13.7808C5.92694 13.4881 5.92661 13.0132 6.21931 12.7201C6.48539 12.4536 6.90204 12.4292 7.1958 12.6468L7.27997 12.7194L10.999 16.433L11 2.755C11 2.37531 11.2822 2.06151 11.6482 2.01185L11.75 2.005L11.6482 2.01185Z"
        fill="#298ee6"
      />
    </svg>
  );
};
export default DownloadIcon;
